import { createFileRoute, redirect } from '@tanstack/react-router';

// Billing details replaces Payment methods. Ember and old bookmarks still use this URL.
export const Route = createFileRoute('/_authenticated/settings/billing/payment-methods')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/billing/billing-details', replace: true });
  },
});
